import type { PillVariant } from "@/components/podkit/status/Pill";
import type { PlainRunner } from "@/queries/runner-queries";
import { RunnerProvider } from "gitpod-next-api/gitpod/v1/runner_configuration_pb";
import { RunnerPhase } from "gitpod-next-api/gitpod/v1/runner_pb";

export type PhaseInfo = {
    variant: PillVariant;
    label: string;
    tooltip?: string;
    /** The phase that determined the label, used for label overrides. */
    matchedPhase?: RunnerPhase;
};

export function getPhaseInfo(runner: PlainRunner): PhaseInfo {
    const actual = runner.status?.phase;
    const message = runner.status?.message || "";
    const desired = runner.spec?.desiredPhase;

    if (desired === RunnerPhase.DELETED) {
        return { variant: "danger", label: "Pending deletion", matchedPhase: RunnerPhase.DELETED };
    }

    switch (actual) {
        case RunnerPhase.ACTIVE:
            return { variant: "success", label: "Online", matchedPhase: RunnerPhase.ACTIVE };
        case RunnerPhase.DEGRADED:
            return {
                variant: "danger",
                label: "Active (Degraded)",
                tooltip: message,
                matchedPhase: RunnerPhase.DEGRADED,
            };
        case RunnerPhase.CREATED:
            return { variant: "warning", label: "Waiting to connect", matchedPhase: RunnerPhase.CREATED };
        case RunnerPhase.DELETING:
            return { variant: "danger", label: "Pending deletion", matchedPhase: RunnerPhase.DELETING };
        case RunnerPhase.INACTIVE:
            return { variant: "danger", label: "Offline", matchedPhase: RunnerPhase.INACTIVE };
        case RunnerPhase.DELETED:
            return { variant: "default", label: "Deleted", matchedPhase: RunnerPhase.DELETED };
        default:
            return { variant: "default", label: "Unknown" };
    }
}

export function getProviderLabel(provider: RunnerProvider): string {
    switch (provider) {
        case RunnerProvider.AWS_EC2:
            return "Amazon EC2";
        case RunnerProvider.GCP:
            return "Google Cloud Platform";
        case RunnerProvider.MANAGED:
            return "Ona Cloud";
        default:
            return "Unknown";
    }
}
